export enum CKPlugins {
    CustomFontColor = 'customFontColor',
    CustomFontFamily = 'customFontFamily',
    CustomFontBackgroundColor= 'customFontBackgroundColor',
};
